import { useState, useRef, useEffect, useCallback } from "react";

interface UseExplosionAnimationOptions {
  delay?: number;
}

export const useExplosionAnimation = (options: UseExplosionAnimationOptions = {}) => {
  const { delay = 200 } = options;
  const [isAnimating, setIsAnimating] = useState(false);
  const animationTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    return () => {
      if (animationTimeoutRef.current) {
        clearTimeout(animationTimeoutRef.current);
      }
    };
  }, []);

  const triggerAnimation = useCallback((callback: () => void) => {
    if (isAnimating) return;
    
    setIsAnimating(true);
    
    animationTimeoutRef.current = setTimeout(() => {
      callback();
    }, delay);
  }, [isAnimating, delay]);

  const resetAnimation = useCallback(() => {
    setIsAnimating(false);
    if (animationTimeoutRef.current) {
      clearTimeout(animationTimeoutRef.current);
      animationTimeoutRef.current = null;
    }
  }, []);

  return {
    isAnimating,
    triggerAnimation,
    resetAnimation,
  };
};

